import { render, staticRenderFns } from "./MaterialStatsCardLoja.vue?vue&type=template&id=4d91191b&scoped=true"
import script from "./MaterialStatsCardLoja.vue?vue&type=script&lang=js"
export * from "./MaterialStatsCardLoja.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatsCardLoja.vue?vue&type=style&index=0&id=4d91191b&prod&scoped=true&lang=css"
import style1 from "./MaterialStatsCardLoja.vue?vue&type=style&index=1&id=4d91191b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91191b",
  null
  
)

export default component.exports